import * as adminService from '@/services/admin'
// import router from '@/router'

const DEFAULT_PAGINATION = {
  current: 1,
  pageSize: 25,
  pageSizeOptions: ['10', '25', '35', '45', '100'],
  showQuickJumper: true,
  showSizeChanger: true,
}
const DEFAULT_FILTERS = null
const DEFAULT_SORTER = { field: 'created_at', order: 'descend' }
const DEFAULT_QUERY = {
  pagination: DEFAULT_PAGINATION,
  filters: DEFAULT_FILTERS,
  sorter: DEFAULT_SORTER,
}
const DEFAULT_META = {
  total: 25,
}

const DEFAULT_MODALS = {
  create: {
    visible: false,
    confirmLoading: false,
  },
}

export default {
  namespaced: true,
  state: {
    loading: false,
    users: null,
    user: null,
    query: DEFAULT_QUERY,
    meta: DEFAULT_META,
    modals: DEFAULT_MODALS,
  },
  getters: {
    loading: (state) => state.loading,
    users: (state) => state.users,
    user: (state) => state.user,
    query: (state) => state.query,
    pagination: (state) => state.query.pagination,
    filters: (state) => state.query.filters,
    sorter: (state) => state.query.sorter,
    meta: (state) => state.meta,
    modals: (state) => state.modals,
    modal_visibility: (state) => (key) => state.modals[key].visible,
  },
  mutations: {
    INIT: (state) => {
      state.loading = false
      state.query = DEFAULT_QUERY
      state.meta = DEFAULT_META
      state.modals = DEFAULT_MODALS
    },
    SET_USERS: (state, users) => {
      state.users = users
    },

    SET_USER: (state, user) => {
      state.user = user
    },
    SET_PAGINATION: (state, pagination) => {
      state.query.pagination = pagination
    },
    SET_FILTERS: (state, filters) => {
      state.query.filters = filters
    },
    SET_SORTER: (state, sorter) => {
      const { field, order } = sorter
      state.query.sorter = { field, order }
    },
    SET_USERS_META: (state, meta) => {
      state.meta = meta
      if (meta.total) state.query.pagination.total = meta.total
    },

    START_LOADING: (state) => {
      state.loading = true
    },

    END_LOADING: (state) => {
      state.loading = false
    },
    // modals
    SET_MODAL_VISIBILITY: (state, { key, visible }) => {
      state.modals[key].visible = visible
    },
  },
  actions: {
    // initialization
    init({ commit }) {
      commit('INIT')
    },

    // set pagination
    setPagination({ commit }, pagination) {
      if (pagination && pagination.current) commit('SET_PAGINATION', pagination)
    },
    // set filters
    setFilters({ commit }, filters) {
      if (filters && Object.keys(filters).length) commit('SET_FILTERS', filters)
    },
    // set sorter
    setSorter({ commit }, sorter) {
      if (sorter && sorter.field) commit('SET_SORTER', sorter)
    },
    // set all query same time
    setQuery({ dispatch }, { pagination, filters, sorter }) {
      dispatch('setPagination', pagination)
      dispatch('setFilters', filters)
      dispatch('setSorter', sorter)
      dispatch('fetchUsers')
    },

    async fetchUsers({ state, commit }) {
      commit('START_LOADING')
      const { users, meta } = await adminService.fetchUsers(state.query)
      if (users) commit('SET_USERS', users)
      if (meta) commit('SET_USERS_META', meta)
      commit('END_LOADING')
      return users
    },

    async fetchUserById({ commit }, id) {
      commit('START_LOADING')
      if (id) {
        const user = await adminService.fetchUserById(id)
        if (user) commit('SET_USER', user)
        return user
      }
      commit('END_LOADING')
    },

    async updateUser({ commit }, user) {
      commit('START_LOADING')
      if (user) {
        const user_updated = await adminService.updateUser(user)
        if (user_updated) commit('SET_USER', user_updated)
        return user_updated
      }
      commit('END_LOADING')
    },
  },
}
